import { Form } from "antd";
import RecommendButton from "./button";
import RecommendItem from "./item";

const Recommendation = ({
  backLoading,
  btnClassName,
  data,
  disabled,
  formRef,
  itemClassName,
  isFinalQuestion,
  isShowBackBtn,
  nextLoading,
  values,
  onBack,
  onFinish,
}) => {
  return (
    <Form
      autoComplete="off"
      initialValues={values}
      name="recommendation-form"
      ref={formRef}
      onFinish={onFinish}
    >
      <RecommendItem
        answers={data?.question?.answers}
        itemClassName={itemClassName}
        question={data?.question?.question}
        priority={data?.question?.priority}
      />
      <RecommendButton
        backLoading={backLoading}
        className={btnClassName}
        disabled={disabled}
        isFinalQuestion={isFinalQuestion}
        isShowBackBtn={isShowBackBtn}
        nextLoading={nextLoading}
        onBack={onBack}
      />
    </Form>
  );
};

export default Recommendation;
